<template>
    <div
        class="detail-bottom-menu"
        :class="theme"
        v-show="showBottomMenu"
    >
        <a
            class="item prev"
            :class="{ disabled: !prevAndNext.canPrev }"
            :disabled="!prevAndNext.canPrev"
            v-show="prevAndNext.show"
            self="true"
            :href="prevAndNext.canPrev ? prevAndNext.prevHref || null : null"
            rel="noopener noreferrer"
        >
            <span class="iconfont icon-next-big"></span>
            <span class="name">{{ $t('md-detail-info.prev') }}</span>
        </a>
        <a
            class="item phone"
            v-if="agent"
            :href="'tel:' + agent.phone"
            target="_top"
            rel="noopener noreferrer"
        >
            <span class="iconfont icon-phone-solid"></span>
            <span class="name">{{ $t('md-detail-info.call') }}</span>
        </a>
        <div class="item tour" @click="schedulePop()" v-show="showTour">
            <span class="iconfont icon-Tour"></span>
            <span class="name">{{ $t('md-detail-info.tour') }}</span>
        </div>
        <a
            class="item next"
            :class="{ disabled: !prevAndNext.canNext }"
            v-show="prevAndNext.show"
            self="true"
            :href="prevAndNext.canNext ? prevAndNext.nextHref || null : null"
            rel="noopener noreferrer"
        >
            <span class="name">{{ $t('md-detail-info.next') }}</span>
            <span class="iconfont icon-next-big"></span>
        </a>
    </div>
</template>

<script>
import { mapActions as rootMapActions } from 'pinia';
import { useChatStore } from '@/store';
import { mapState } from '@/store/helpers';
import global from '../../common/global';
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    props: {
        theme: {
            required: true,
            type: String
        },
        isOffer: {
            type: Boolean,
            default: false
        },
        scroll: {
            type: Boolean,
            default: true
        }
    },
    inject: ['onFavoriteClick', 'sharePop', 'schedulePop'],
    data: function() {
        return {
            hidden: false
        };
    },
    mounted() {
        if (!this.scroll) {
            return; 
        }
        this.onScroll();
        global.scroll(this.onScroll);
    },
    computed: {
        ...mapState({
            'agent': store => store.agentInfo,
            'prevAndNext': store => store.prevAndNext || {},
            'showTour': store => {
                let { info = {} } = store.listingDetail || {}; return info.listingStatus != 'Sold'; 
            }
        }),
        //  When none of the four buttons are displayed
        showBottomMenu({ hidden, agent, prevAndNext, showTour }) {
            return  !hidden && !!(agent || prevAndNext?.show || showTour);
        }
    },
    watch: {
        showBottomMenu: {
            handler(a) {
                if (a) {
                    this.updateChatPosition({ mBottom: '80px' });
                } else {
                    this.resetChatPosition()
                }
            },
            immediate: true
        }
    },
    unmounted() {
        global.scroll(this.onScroll, true);
    },
    methods: {
        ...rootMapActions(useChatStore, ['updateChatPosition', 'resetChatPosition']),
        onScroll() {
            let moduleData = this.$root.moduleData;
            let module = moduleData[moduleData.length - 1];
            let vm = module.vm;
            if (vm && vm.$el) {
                let lastElem = vm.$el;
                let lastRect = lastElem.getBoundingClientRect();
                if (lastRect.bottom - 20 <= window.innerHeight) {
                    this.hidden = true;
                } else {
                    this.hidden = false;
                }
            }
        }
    }
};
</script>
<style lang="scss">
@import '../../theme/media.scss';
@import '../../theme/mixin.scss';
@media (min-width: 601px) {
    .detail-bottom-menu {
        display: none;
    }
}
@mixin disabled-btn-color($color: #c2c2c2) {
    .item.disabled {
        color: $color;
    }
}
@include media-600 {
    .detail-bottom-menu {
        z-index: 2;
        display: flex;
        height: 44px;
        font-size: 12px;
        position: fixed;
        left: 0;
        right: 0;
        bottom: 20px;
        overflow: hidden;
        border-radius: 22px;
        box-shadow: 0 4px 10px 3px rgba(170, 186, 218, 0.3);
        background-color: #ffffff;
        width: calc(100% - 30px);
        margin: 0 auto;
        transform: rotate(0deg);
        &.broker {
            z-index: var(--level-sublow);
            .item:after {
                color: #dadada;
            }
        }
        .item {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            &.prev,
            &.next {
                .iconfont {
                    font-size: 12px;
                }
            }
            .name {
                margin-left: 6px;
                font-size: 14px;
            }
            &.phone,
            &.tour {
                color: var(--color-theme);
                .iconfont {
                    font-size: 16px;
                }
            }
            &.prev {
                .iconfont {
                    transform: rotate(180deg);
                }
            }
            &.phone {
            }
            &.tour {
            }
            &.next {
                .name {
                    margin-left: 0;
                    margin-right: 6px;
                }
            }
            &.disabled {
                color: #c6c9d2;
            }
            &:after {
                content: '|';
                height: 15px;
                width: 1px;
                background-color: #f1f2f3;
                position: absolute;
                right: 0;
                color: #f1f2f3;
            }
            &:last-child {
                &:after {
                    display: none;
                }
            }
        }
        &.classic {
            @include disabled-btn-color(#c2c2c2);
        }
        &.standard {
            @include disabled-btn-color(#c6c9d2);
        }
        &.broker {
            @include disabled-btn-color(#c6c9d2);
        }
        &.fashion {
            @include disabled-btn-color(#d1d4dc);
        }
    }
}
</style>
